module.exports = __webpack_public_path__ + "img/login_bg.c62a9871.png";